import { splitWords } from '../../widgets/utils';
import { CanvasObject } from './CanvasObject';
import { Controller } from './Controller';
import { Ring } from './Ring';
import { IBlock } from './temp';

interface IAnnouncer {
  message: string;
}


export class Announcer extends CanvasObject<IAnnouncer> {

  constructor(
    c: CanvasRenderingContext2D,
    protected _x: number,
    protected _y: number,
    public meta: IAnnouncer
  ) {
    super(_x, _y, meta);
  }

  public set message(message: string) {
    this.meta.message = message;
  }

  public update(
    controller: Controller,
    canvas: HTMLCanvasElement,
    c: CanvasRenderingContext2D
  ) {
    c.beginPath();

    c.beginPath();
    c.font = `24px Arial`;
    c.fillStyle = '#FFF';
    const m = c.measureText(this.meta.message)
    const {x, y} = this.getTransformedPoint(c, canvas.width/2, 48);
    c.font = `${24 * controller.cameraZoom}px Arial`;
    // x / cw = 24/z => z = 24 * cw/x
    c.fillText(this.meta.message, x, y, m.width);
    c.fill();
  }

}
